/* src/app/promo-plan/view-promo-plan/view-promo-plan.component.css */
.customized-timeline .p-timeline-event-opposite {
  flex: 0;
  padding: 0;
}
/*# sourceMappingURL=view-promo-plan.component-COYMCQM4.css.map */
